
import React, { Component } from "react";
import { connect } from "react-redux";

import ModalDialog from "components/ModalDialog";
import { isLoadingFrameOpen } from "state/app/selectors";

import "./LoadingFrame.css";

const LOADING_TEXTS = [
  "Fetching data…",
  "Almost there…",
  "Not long now…"
];

class LoadingFrame extends Component {
  state = {
    textIndex: 0,
    intervalId: null,
  };

  componentDidMount() {
    if (this.props.isOpen) {
      this.startTextRotation();
    }
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props;

    // When modal opens: reset index and start rotation
    if (!prevProps.isOpen && isOpen) {
      this.setState({ textIndex: 0 }, this.startTextRotation);
    }

    // When modal closes: clear timer & reset index
    if (prevProps.isOpen && !isOpen) {
      this.stopTextRotation();
      this.setState({ textIndex: 0 });
    }
  }

  componentWillUnmount() {
    this.stopTextRotation();
  }

  startTextRotation = () => {
    // Ensure we don't create multiple timers
    this.stopTextRotation();

    const intervalId = setInterval(() => {
      this.setState((prev) => {
        const lastIdx = LOADING_TEXTS.length - 1;

        if (prev.textIndex < lastIdx) {
          return { textIndex: prev.textIndex + 1 };
        } else {
          // at last index keep showing last text and clear interval
          if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
          }
          return { intervalId: null };
        }
      });
    }, 5000);

    this.setState({ intervalId });
  };

  stopTextRotation = () => {
    const { intervalId } = this.state;
    if (intervalId) {
      clearInterval(intervalId);
      this.setState({ intervalId: null });
    }
  };

  render() {
    const { isOpen } = this.props;
    if (!isOpen) return null;

    const { textIndex } = this.state;
    const currentText = LOADING_TEXTS[textIndex];

    return (
      <ModalDialog isOpen={isOpen}>
        <div className="loading-frame__content">
          <div className="loading-frame__text">
            {currentText}
          </div>

          <div className="loading-frame">
            <div className="throbber">
              <div className="bounce1" />
              <div className="bounce2" />
              <div className="bounce3" />
            </div>
          </div>
        </div>
      </ModalDialog>
    );
  }
}

export default connect((state) => ({
  isOpen: isLoadingFrameOpen(state)
}))(LoadingFrame);



// WEBPACK FOOTER //
// ./src/components/app/LoadingFrame.js